// polyfill still needed for Edge 18
import 'fast-text-encoding';

const bufferToHex = (buffer: ArrayBufferLike) => {
  const view = new DataView(buffer);

  let hexCodes = '';
  for (let i = 0; i < view.byteLength; i += 4) {
    hexCodes += view.getUint32(i).toString(16).padStart(8, '0');
  }

  return hexCodes;
};

const sha256 = async (query: string) => {
  const buffer = new TextEncoder().encode(query);
  const hash = await crypto.subtle.digest('SHA-256', buffer);

  return bufferToHex(hash);
};

export default sha256;
